module.exports = __webpack_public_path__ + "static/media/logo_medium.9a491c22.png";